// extracted by mini-css-extract-plugin
export var chatHtmlText = "_n9-2";
export var chatLink = "_n9-0";
export var chatText = "_n9-1";